import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { useMutation } from "@apollo/react-hooks";
import { InputAdornment, TextField } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import SendIcon from "@iconify/icons-mdi/send";
import { InlineIcon } from "@iconify/react";
import { myTimeMessageState } from "my-time/states/my-time-message";
import { CREATE_MY_TIME_SHEET_MESSAGE } from "my-timesheet/graphql";

type MyTimesheetNewMessageProps = {
  loading: boolean;
  selectedRequest: string;
  disabled?: boolean;
  refetch: () => void;
};

export const MyTimesheetNewMessage = ({
  loading,
  selectedRequest,
  disabled = false,
  refetch,
}: MyTimesheetNewMessageProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const [message, setMessage] = useRecoilState(myTimeMessageState);
  const [error, setError] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMessage(e.target.value);
  };

  const [createMySheetMessage] = useMutation(CREATE_MY_TIME_SHEET_MESSAGE, {
    onCompleted: () => {
      refetch();
    },
  });

  const handleSubmit = () => {
    if (!message) {
      setError(true);
      return;
    }
    const params = {
      request: selectedRequest,
      message: message,
      //employee: employee,
    };
    createMySheetMessage({
      variables: params,
    });
    setMessage("");
  };

  return (
    <TextField
      id="new-message-box-input"
      multiline={message?.length > 50 ? true : false}
      fullWidth
      variant="outlined"
      placeholder={t("OC_WRITE_MESSAGE")}
      value={message}
      onChange={handleChange}
      onFocus={() => setError(false)}
      error={error}
      helperText={error ? `${t("OC_EMPTY_MESSAGE")}` : `${message.length}/255`}
      style={{
        height: "auto",
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          height: "56px",
          paddingRight: "12px",
        },
      }}
      disabled={disabled}
      slotProps={{
        htmlInput: {
          maxLength: 255,
        },
        input: {
          disabled: loading || disabled,
          style: {
            backgroundColor: "white",
          },
          endAdornment: (
            <InputAdornment position="end">
              <InlineIcon
                id="my-timesheet-new-message-button"
                icon={SendIcon}
                //className={classes.iconSend}
                onClick={handleSubmit}
                style={{
                  cursor: "pointer",
                  backgroundColor: theme.palette.gray20.main,
                  padding: "13px",
                  borderRadius: "25px",
                  width: "22px",
                  height: "22px",
                  color: theme.palette.gray60.main,
                }}
              />
            </InputAdornment>
          ),
        },
        formHelperText: error
          ? { style: { textAlign: "left" } }
          : { style: { textAlign: "right" } },
      }}
    />
  );
};

export default MyTimesheetNewMessage;
